import { render } from "./AppsManagement.vue?vue&type=template&id=74378cb9&scoped=true"
import script from "./AppsManagement.vue?vue&type=script&lang=js"
export * from "./AppsManagement.vue?vue&type=script&lang=js"

import "./AppsManagement.vue?vue&type=style&index=0&id=74378cb9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74378cb9"]])

export default __exports__